// extracted by mini-css-extract-plugin
export var heroImage = "_ge-1";
export var modal = "_ge-0";